var _circle, _circle2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgEmptyJoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 85,
    fill: "#FFF1F1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 85.5,
    r: 27.5,
    fill: "#FFF1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 77.2308L80.61 75.4377C80.884 74.9953 81.2552 74.6327 81.6907 74.3819C82.1261 74.1311 82.6122 73.9999 83.106 74H87.894C88.3878 73.9999 88.8739 74.1311 89.3093 74.3819C89.7448 74.6327 90.116 74.9953 90.39 75.4377L91.5 77.2308H99V95H72V77.2308H79.5Z",
    stroke: "#FF6262",
    strokeWidth: 1.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86 90C88.7614 90 91 87.7614 91 85C91 82.2386 88.7614 80 86 80C83.2386 80 81 82.2386 81 85C81 87.7614 83.2386 90 86 90Z",
    stroke: "#FF6262",
    strokeWidth: 1.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEmptyJoin);
export default __webpack_public_path__ + "static/media/img_empty_join.83988660d6f83c5e54fd4d39ca7ee7b9.svg";
export { ForwardRef as ReactComponent };